import AdminAppeal from "./BO/Appeal/AdminAppeal";
import AdminBackupManager from "./BO/backup-manager/AdminBackupManager";
import AdminBranches from "./BO/Branches/AdminBranches";
import AdminCountries from "./BO/Countries/AdminCountries";
import AdminCountryHolidays from "./BO/Countries/AdminCountryHolidays";
import AdminCurrencies from "./BO/Currency/AdminCurrency";
import AdminExchangeRate from "./BO/Currency/AdminExchangeRate";
import AdminJobCategory from "./BO/JobCategory/AdminJobCategory";
import AdminJobs from "./BO/Jobs/AdminJobs";
import AdminPage from "pages/admin/Admin";
import AdminProfile from "./BO/Profile/AdminProfile";
import AdminReasonLeave from "./BO/ReasonLeave/AdminReasonLeave";
import AdminRecruitmentMethods from "./BO/RecruitmentMethods/AdminRecruitmentMethods";
import AdminRegions from "./BO/Regions/AdminRegions";
import AdminSector from "./BO/Sector/AdminSector";
import AdminSyntec from "./BO/Syntec/AdminSyntec";
import AdminSyntecPosCoef from "./BO/SyntecPosCoef/AdminSyntecPosCoef";
import AdminSyntecPosCoefStaff from "./BO/SyntecPosCoef-staff/AdminSyntecPosCoefStaff";
import AdminTtv from "./BO/TTV/AdminTtv";
import AdminTypeCompanies from "./BO/TypeCompanies/AdminTypeCompanies";
import AdminDoc from "./BO/Document/AdminDoc";
import { ACTIONS } from "constants/constants";
import { Route } from "react-router-dom";

const routes = {
  key: "ADMIN",
  routes: ({ userScope }) => [
    <Route
      key={"admin-page"}
      path={`${userScope}/settings/`}
      element={<AdminPage />}
    >
      {/* Routes admin branches */}
      <Route path="branches" key={"branches"}>
        <Route path="" element={<AdminBranches action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminBranches action={ACTIONS.CREATE} />} />
        <Route
          path=":id"
          element={<AdminBranches action={ACTIONS.DETAILS} />}
        />
        <Route
          path="edit/:id"
          element={<AdminBranches action={ACTIONS.EDIT} />}
        />
      </Route>
      {/* Routes admin countries */}
      <Route
        path="countries"
        element={<AdminCountries action={ACTIONS.LIST} />}
      />
      <Route
        path="countries/new"
        element={<AdminCountries action={ACTIONS.CREATE} />}
      />
      <Route
        path="countries/edit/:id"
        element={<AdminCountries action={ACTIONS.EDIT} />}
      />
      <Route
        path="countries/:id"
        element={
          <AdminCountries action={ACTIONS.DETAILS} actionCoefx={ACTIONS.LIST} />
        }
      />
      <Route
        path="countries/:id/coefx/:coefxID"
        element={<AdminCountries actionCoefx={ACTIONS.DETAILS} />}
      />
      <Route
        path="countries/:id/coefx/edit/:coefxID"
        element={<AdminCountries actionCoefx={ACTIONS.EDIT} />}
      />
      <Route
        path="countries/:id/coefx/new"
        element={<AdminCountries actionCoefx={ACTIONS.CREATE} />}
      />

      {/* Routes admin country-holidays */}
      <Route
        path="country-holidays"
        element={<AdminCountryHolidays action={ACTIONS.LIST} />}
      />
      <Route
        path="country-holidays/:id"
        element={<AdminCountryHolidays action={ACTIONS.DETAILS} />}
      />
      <Route
        path="country-holidays/new"
        element={<AdminCountryHolidays action={ACTIONS.CREATE} />}
      />
      <Route
        path="country-holidays/edit/:id"
        element={<AdminCountryHolidays action={ACTIONS.EDIT} />}
      />
      <Route
        path="countries/:id"
        element={<AdminCountries action={ACTIONS.DETAILS} />}
      />
      {/* Routes admin exchange rate */}
      <Route path="exchange-rate">
        <Route path="" element={<AdminExchangeRate action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminExchangeRate action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminExchangeRate action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminExchangeRate action={ACTIONS.DETAILS} />}
        />
        <Route
          path="upload"
          element={<AdminExchangeRate action={ACTIONS.UPLOAD} />}
        />
      </Route>
      {/* Routes admin currency */}
      <Route path="currency">
        <Route path="" element={<AdminCurrencies action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminCurrencies action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminCurrencies action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminCurrencies action={ACTIONS.DETAILS} />}
        />
      </Route>
      {/* Routes admin profile */}
      <Route path={`profile`}>
        <Route path="" element={<AdminProfile action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminProfile action={ACTIONS.CREATE} />} />
        <Route
          path="edit/:id"
          element={<AdminProfile action={ACTIONS.EDIT} />}
        />
        <Route path=":id" element={<AdminProfile action={ACTIONS.DETAILS} />} />
      </Route>
      {/* Routes admin reason leave */}
      <Route path={`reasonleave`}>
        <Route path="" element={<AdminReasonLeave action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminReasonLeave action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminReasonLeave action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminReasonLeave action={ACTIONS.DETAILS} />}
        />
      </Route>
      {/* Routes admin typecompanies */}
      <Route path="typecompanies">
        <Route path="" element={<AdminTypeCompanies action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminTypeCompanies action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminTypeCompanies action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminTypeCompanies action={ACTIONS.DETAILS} />}
        />
      </Route>
      {/* Routes admin recruitmentmethods */}
      <Route path="recruitmentmethods">
        <Route
          path=""
          element={<AdminRecruitmentMethods action={ACTIONS.LIST} />}
        />
        <Route
          path="new"
          element={<AdminRecruitmentMethods action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminRecruitmentMethods action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminRecruitmentMethods action={ACTIONS.DETAILS} />}
        />
      </Route>
      {/* Routes admin sector */}
      <Route path="sector">
        <Route path="" element={<AdminSector action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminSector action={ACTIONS.CREATE} />} />
        <Route
          path="edit/:id"
          element={<AdminSector action={ACTIONS.EDIT} />}
        />
        <Route path=":id" element={<AdminSector action={ACTIONS.DETAILS} />} />
      </Route>
      {/* Routes admin syntec */}
      <Route path="syntec">
        <Route path="" element={<AdminSyntec action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminSyntec action={ACTIONS.CREATE} />} />
        <Route
          path="edit/:id"
          element={<AdminSyntec action={ACTIONS.EDIT} />}
        />
        <Route path=":id" element={<AdminSyntec action={ACTIONS.DETAILS} />} />
      </Route>
      {/* Routes admin syntecposcoef */}
      <Route path="syntecposcoef">
        <Route path="" element={<AdminSyntecPosCoef action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminSyntecPosCoef action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminSyntecPosCoef action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminSyntecPosCoef action={ACTIONS.DETAILS} />}
        />
      </Route>
      <Route path="syntecposcoef-staff">
        <Route
          path=""
          element={<AdminSyntecPosCoefStaff action={ACTIONS.LIST} />}
        />
        <Route
          path="new"
          element={<AdminSyntecPosCoefStaff action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminSyntecPosCoefStaff action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminSyntecPosCoefStaff action={ACTIONS.DETAILS} />}
        />
      </Route>
      <Route path="appeal"></Route>
      {/* Routes admin job */}
      <Route path="jobs">
        <Route path="" element={<AdminJobs action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminJobs action={ACTIONS.CREATE} />} />
        <Route path="edit/:id" element={<AdminJobs action={ACTIONS.EDIT} />} />
        <Route path=":id" element={<AdminJobs action={ACTIONS.DETAILS} />} />
      </Route>
      {/* Routes admin job categories */}
      <Route path="job-categories">
        <Route path="" element={<AdminJobCategory action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminJobCategory action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminJobCategory action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminJobCategory action={ACTIONS.DETAILS} />}
        />
      </Route>
      {/* Routes admin ttv */}
      <Route path="ttv">
        <Route path="" element={<AdminTtv action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminTtv action={ACTIONS.CREATE} />} />
        <Route path="edit/:id" element={<AdminTtv action={ACTIONS.EDIT} />} />
        <Route path=":id" element={<AdminTtv action={ACTIONS.DETAILS} />} />
      </Route>
      <Route path="regions">
        <Route path="" element={<AdminRegions action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminRegions action={ACTIONS.CREATE} />} />
        <Route
          path="edit/:id"
          element={<AdminRegions action={ACTIONS.EDIT} />}
        />
        <Route path=":id" element={<AdminRegions action={ACTIONS.DETAILS} />} />
      </Route>

      <Route path="appeal">
        <Route path="" element={<AdminAppeal action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminAppeal action={ACTIONS.CREATE} />} />
        <Route
          path="edit/:id"
          element={<AdminAppeal action={ACTIONS.EDIT} />}
        />
        <Route path=":id" element={<AdminAppeal action={ACTIONS.DETAILS} />} />
      </Route>
      {/* Routes admin manager backup */}
      <Route path="manager-backup">
        <Route path="" element={<AdminBackupManager action={ACTIONS.LIST} />} />
        <Route
          path="new"
          element={<AdminBackupManager action={ACTIONS.CREATE} />}
        />
        <Route
          path="edit/:id"
          element={<AdminBackupManager action={ACTIONS.EDIT} />}
        />
        <Route
          path=":id"
          element={<AdminBackupManager action={ACTIONS.DETAILS} />}
        />
      </Route>
      {/* Routes admin documents */}
      <Route path="document">
        <Route path="" element={<AdminDoc action={ACTIONS.LIST} />} />
        <Route path="new" element={<AdminDoc action={ACTIONS.CREATE} />} />
        <Route path="edit/:id" element={<AdminDoc action={ACTIONS.EDIT} />} />
        <Route path=":id" element={<AdminDoc action={ACTIONS.DETAILS} />} />
      </Route>
    </Route>,
  ],
};

export default routes;
